<template>
  <OmtGrid
    class="refund-audit-page refund-audit-term-page"
    :class="termPageClass"
  >
    <OmtRow
      :desktopStart="2"
      :desktopEnd="11"
      :mb="headerMarginBottom"
    >
      <OmtTypography
        as="h1-bold"
        class="refund-audit-term-title"
      >
        {{ header }}
      </OmtTypography>
    </OmtRow>

    <OmtRow
      v-if="subHeader"
      :desktopStart="2"
      :desktopEnd="11"
      :mb="description ? (isUnpaidScenario ? '8px' : '16px') : ''"
    >
      <OmtTypography
        :as="subHeaderTypography"
        class="refund-audit-term-subtitle"
      >
        {{ subHeader }}
      </OmtTypography>
    </OmtRow>

    <OmtRow
      v-if="description"
      :desktopStart="2"
      :desktopEnd="11"
    >
      <OmtTypography
        as="p1"
        class="refund-audit-term-description"
      >
        {{ description }}
      </OmtTypography>
    </OmtRow>

    <OmtRow
      :desktopStart="2"
      :desktopEnd="11"
    >
      <OmtDivider
        :mt="dividerMarginTop"
        :mb="dividerMarginBottom"
        w="100%"
      />
    </OmtRow>

    <OmtRow
      :desktopStart="2"
      :desktopEnd="11"
      mb="32px"
    >
      <CBox
        v-if="!usesListTerms"
        class="refund-audit-term-content"
        v-html="termsText"
      />
      <ul
        v-else
        class="refund-audit-term-content refund-audit-term-list"
      >
        <li
          v-for="(term, index) in terms"
          :key="index"
          v-html="term"
        />
      </ul>
    </OmtRow>

    <OmtRow
      :desktopStart="2"
      :desktopEnd="11"
    >
      <CBox>
        <CStack
          class="refund-audit-term-actions"
          :position="['fixed', 'relative']"
          :bottom="[actionsBottom, '0']"
          :left="['16px', '0']"
          :right="['16px', '0']"
        >
          <OmtCheckbox
            class="refund-audit-term-checkbox"
            :is-checked="optin"
            @change="optin = !optin"
          >
            <OmtTypography
              as="p1"
              class="refund-audit-term-checkbox__label"
            >
              {{ confirmationText }}
            </OmtTypography>
          </OmtCheckbox>

          <OmtButton
            :m="['32px 0 0 0', '32px auto 0 auto']"
            :w="['100%', '30%']"
            :disabled="!optin"
            class="refund-audit-term-continue-button"
            fontSize="20px"
            fontWeight="700"
            lineHeight="24px"
            @click="submit"
          >
            Continuar
          </OmtButton>
        </CStack>
        <CBox
          v-if="scenario !== 3 && !isUnpaidScenario"
          :height="['124px', '0']"
          w="50%"
        />
      </CBox>
    </OmtRow>

    <CancellationDetailsModal
      :is-open.sync="showCancellationDetailsModal"
      @submit="handlePendencyModalSubmit"
    />

    <AuditFeedbackModal
      v-if="showFeedbackModal"
      :protocol="modalInfos.protocol"
      :title="modalInfos.title"
      :cardTitle="modalInfos.cardTitle"
      :cardDescription="modalInfos.cardDescription"
      :cardIcon="modalInfos.cardIcon"
      :modalIconBind="modalInfos.modalIconBind"
      :buttonLabel="modalInfos.buttonLabel"
      :secondButtonLabel="modalInfos.secondButtonLabel"
      :showAnalysisProtocol="scenario === 3"
      :securityRecommendations="[3, 4, 6].includes(scenario)"
      :showCancellationNotice="scenario === 5"
      @buttonClick="modalInfos.buttonClick"
      @close="modalInfos.close"
    />
  </OmtGrid>
</template>

<script>
import generateAuditTerms from "@/components/Organisms/RefundNew/fixture/generate-audit-terms.js";
import AuditFeedbackModal from "@/components/Organisms/RefundNew/AuditFeedbackModal.vue";
import CancellationDetailsModal from "@/components/Organisms/RefundNew/AuditForm/CancellationDetailsModal.vue";
import { FormsOptions } from "@/components/Organisms/RefundNew/AuditForm/scenarios";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    AuditFeedbackModal,
    CancellationDetailsModal
  },
  data() {
    return {
      showFeedbackModal: false,
      showCancellationDetailsModal: false,
      optin: false,
      paidWithCash: null,
      sharedCredential: false,
      protocol: "",
      scenario: null,
      answers: [],
      refund: {},
      ticket: ""
    };
  },
  computed: {
    ...mapState("saude", ["contratType"]),
    singlePlan() {
      return this.contratType === "F";
    },
    modalInfos() {
      const modalHeaderByType = {
        pendency: {
          title: "Respostas enviadas para análise",
          modalIconBind: {
            name: "clock",
            color: "var(--colors-light-primary-dark-blue)"
          }
        },
        cancellation: {
          title: "Esta solicitação de reembolso foi cancelada",
          modalIconBind: {
            name: "circle-exclamation",
            color: "var(--colors-light-support-warning)"
          }
        }
      };

      const modalInnerCardContentByType = {
        "change-password": {
          cardTitle: "É necessário que você altere a senha do seu APP",
          cardDescription: `
            Como você forneceu sua senha para um prestador de serviço, a <b>alteração de senha é obrigatória.</b>
            <br/>
            Isso é necessário para prevenirmos a <b>utilização indevida de seu acesso.</b>
            <br/>
            Caso a senha não seja alterada, <b>seu acesso poderá ser bloqueado.</b>
          `
        },
        "security-recommendation": {
          cardTitle: "Previna-se contra o uso irregular do seu plano",
          cardDescription: `
            <ul>
              <li>
                <b>Nunca forneça sua senha do APP</b> para terceiros ou prestadores de serviços e troque-a periodicamente.
              </li>
              <li>
                <b>Nunca aceite “serviços e facilidades suspeitas”</b>, oferecidas por terceiros, mesmo que sejam prestadores de serviços médicos.
              </li>
              <li>
                Mantenha suas <b>informações pessoais atualizadas</b>.
              </li>
              <li>
                <b>Confira as informações nos documentos apresentados </b>e, em caso de dúvidas, contate a Central de Atendimento Omint.
              </li>
            </ul>
          `
        }
      };

      const mustChangePassword = [1, 2, 5].includes(this.scenario) || this.sharedCredential;

      return {
        protocol: this.protocol,
        ...modalHeaderByType[[2, 3].includes(this.scenario) ? "pendency" : "cancellation"],
        ...modalInnerCardContentByType[
          [1, 2, 5].includes(this.scenario) ? "change-password" : "security-recommendation"
        ],
        cardIcon: "lock",
        buttonLabel: [3, 4, 6].includes(this.scenario) ? "Concluir" : "Continuar",
        buttonClick: () => this.pushNextRoute(mustChangePassword),
        close: () => this.pushNextRoute(mustChangePassword)
      };
    },
    isUnpaidScenario() {
      return [4, 5].includes(this.scenario);
    },
    terms() {
      return generateAuditTerms(this.scenario);
    },
    termsText() {
      return (this.terms || []).map(term => term.replace(/^<span>/, "").replace(/<\/span>$/, "")).join(" ");
    },
    usesListTerms() {
      return [3, 6].includes(this.scenario);
    },
    isConfirmationScenario() {
      return [2, 3].includes(this.scenario);
    },
    isCancellationScenario() {
      return [1, 6].includes(this.scenario);
    },
    termPageClass() {
      return {
        "refund-audit-term-page--confirmation": this.isConfirmationScenario,
        "refund-audit-term-page--paid-private": this.scenario === 3,
        "refund-audit-term-page--unpaid": this.isUnpaidScenario,
        "refund-audit-term-page--cancellation": this.isCancellationScenario
      };
    },
    headerMarginBottom() {
      if (this.isUnpaidScenario) return "8px";
      if (this.isConfirmationScenario) return "0";
      if (this.isCancellationScenario) return "8px";
      return "24px";
    },
    subHeaderTypography() {
      return this.isConfirmationScenario || this.isUnpaidScenario ? "p1-bold" : "h3-bold";
    },
    dividerMarginTop() {
      if (this.isUnpaidScenario) return "16px";
      if (this.isConfirmationScenario) return "19px";
      if (this.isCancellationScenario) return "24px";
      return "24px";
    },
    dividerMarginBottom() {
      if (this.isConfirmationScenario) return "19px";
      if (this.isCancellationScenario) return "22px";
      return "24px";
    },
    actionsBottom() {
      return this.isConfirmationScenario ? "30px" : "16px";
    },
    confirmationText() {
      if (this.isConfirmationScenario || this.isUnpaidScenario)
        return "Confirmo que estou de acordo com as declarações e orientações descritas acima.";
      return "Confirmo que estou de acordo com as declarações descritas acima.";
    },
    header() {
      if ([1, 4, 5].includes(this.scenario)) return "Esta solicitação de reembolso será cancelada";
      if ([2, 3].includes(this.scenario)) return "Termo de orientações e declarações";
      return "Cancelamento de solicitação de reembolso";
    },
    subHeader() {
      if ([2, 3].includes(this.scenario))
        return "Por favor, leia as declarações abaixo e realize os procedimentos solicitados.";
      if ([4, 5].includes(this.scenario))
        return "A solicitação de reembolso só é permitida após o pagamento das despesas.";
      return "";
    },
    description() {
      if ([1, 6].includes(this.scenario))
        return "Para cancelarmos a solicitação de reembolso é necessário que você leia e confirme que está de acordo com as declarações abaixo:";
      if ([4, 5].includes(this.scenario)) return "Leia atentamente os termos abaixo para continuar:";
      return "";
    }
  },
  mounted() {
    this.scenario = Number(this.$route.params.scenario || this.$route.query.scenario);
    this.refund = this.$route.params.refund;
    this.ticket = this.$route.params.ticket;
    this.mustCancelProtocol = this.$route.params.mustCancelProtocol;

    if (this.$route.params.answers) {
      this.answers = this.$route.params.answers;

      const paymentTypeAnswer = this.answers.find(
        answer => answer.component === FormsOptions[FormsOptions.AuditFormPaymentType]
      );
      this.paidWithCash = paymentTypeAnswer?.value === 11;

      const sharedCredentialAnswer = this.answers.find(
        answer => answer.component === FormsOptions[FormsOptions.AuditFormSharedCredentials]
      );
      this.sharedCredential = sharedCredentialAnswer?.value === 9;
    }
  },
  methods: {
    ...mapActions("refund", ["finishAudit", "cancelAudit"]),
    async handleFinishAudit({ obs = null, cb = () => {} }) {
      try {
        await this.$root.$emit("show-loading");
        let auditProtocol;

        if (this.mustCancelProtocol) {
          auditProtocol = await this.cancelAudit({
            ticket: this.ticket,
            protocol: this.refund.protocol,
            obs
          });
        } else {
          auditProtocol = await this.finishAudit({
            obs
          });
        }

        this.protocol = auditProtocol;
        cb();
      } catch (error) {
        this.$toast({
          description: error.message,
          status: "error",
          duration: 10000,
          position: "top"
        });
      } finally {
        await this.$root.$emit("hide-loading");
      }
    },
    submit() {
      if (!this.optin) return;
      if ([1, 6].includes(this.scenario)) {
        this.showCancellationDetailsModal = true;
      } else {
        this.handleFinishAudit({
          cb: () => {
            this.showFeedbackModal = true;
          }
        });
      }
    },
    handlePendencyModalSubmit(answers) {
      this.handleFinishAudit({
        obs: answers.obs,
        cb: () => {
          this.showCancellationDetailsModal = false;
          this.showFeedbackModal = true;
        }
      });
    },
    pushNextRoute(mustChangePassword) {
      const routerBody = mustChangePassword
        ? {
            name: "change.password",
            params: {
              forceChange: true
            }
          }
        : {
            path: "/refund-new/list"
          };

      this.$router.push(routerBody);
    }
  }
};
</script>

<style scoped>
.refund-audit-page {
  align-content: start;
}

.refund-audit-term-subtitle,
.refund-audit-term-description,
.refund-audit-term-content,
.refund-audit-term-checkbox__label {
  line-height: 22px !important;
}

.refund-audit-term-content {
  color: var(--colors-light-primary-gray1);
  font-family: "Open Sans", Roboto, sans-serif;
  font-size: 14px;
}

.refund-audit-term-page--confirmation .refund-audit-term-content {
  width: 345px;
  max-width: calc(100vw - 30px);
  min-height: 442px;
  font-weight: 700;
}

.refund-audit-term-page--cancellation .refund-audit-term-title {
  width: 300px;
}

.refund-audit-term-page--cancellation .refund-audit-term-content {
  width: 323px;
  max-width: calc(100vw - 32px);
  min-height: 162px;
  font-weight: 400;
}

.refund-audit-term-actions {
  z-index: var(--zIndices-popover);
  background: var(--colors-light-neutral-white);
}

.refund-audit-term-checkbox {
  align-items: flex-start !important;
  transform: translateY(8px);
}

.refund-audit-term-page--confirmation .refund-audit-term-checkbox {
  transform: translateY(7px);
}

.refund-audit-term-checkbox__label {
  width: 100%;
  max-width: 311px;
  min-width: 0;
  margin-left: 16px;
  color: var(--colors-light-primary-gray1);
}

.refund-audit-term-checkbox::v-deep input[type="checkbox"] + div {
  width: 16px !important;
  height: 16px !important;
  margin-top: 5px;
  border-radius: 4px !important;
}

.refund-audit-term-page--confirmation .refund-audit-term-checkbox::v-deep input[type="checkbox"] + div {
  margin-top: 13px;
}

.refund-audit-term-checkbox::v-deep input[type="checkbox"]:checked + div {
  border-color: var(--colors-light-primary-navy-blue) !important;
  background: var(--colors-light-primary-navy-blue) !important;
}

.refund-audit-term-continue-button {
  font-size: 20px !important;
  font-weight: 700 !important;
  line-height: 24px !important;
}

.refund-audit-term-page--paid-private .refund-audit-term-list {
  display: block;
  width: 100%;
  max-width: 100%;
  min-height: 0;
  margin: 0;
  padding-left: 22px;
  list-style: disc;
  font-weight: 400;
}
.refund-audit-term-list li + li {
  margin-top: 8px;
}
.refund-audit-term-page--paid-private .refund-audit-term-actions {
  position: relative !important;
  inset: auto !important;
}
.refund-audit-term-page--paid-private .refund-audit-term-checkbox {
  transform: none;
}
.refund-audit-term-page--cancellation .refund-audit-term-list {
  display: block;
  margin: 0;
  padding-left: 22px;
  list-style: disc;
}
.refund-audit-term-page--unpaid .refund-audit-term-content::v-deep ul {
  display: block;
  margin: 0;
  padding-left: 22px;
  list-style: disc;
}
.refund-audit-term-page--unpaid .refund-audit-term-content::v-deep li + li {
  margin-top: 8px;
}
.refund-audit-term-page--unpaid .refund-audit-term-content::v-deep p {
  margin: 8px 0;
}
.refund-audit-term-page--unpaid .refund-audit-term-actions {
  position: relative !important;
  inset: auto !important;
}
.refund-audit-term-page--unpaid .refund-audit-term-checkbox {
  transform: none;
}
@media screen and (min-width: 1024px) {
  .refund-audit-page {
    max-width: 1104px;
  }

  .refund-audit-term-page--confirmation .refund-audit-term-content,
  .refund-audit-term-page--cancellation .refund-audit-term-content,
  .refund-audit-term-page--cancellation .refund-audit-term-title {
    width: 100%;
    max-width: 100%;
    min-height: 0;
  }

  .refund-audit-term-actions {
    background: transparent;
  }

  .refund-audit-term-checkbox__label {
    max-width: 100%;
  }
}
</style>
